import React from 'react';
import {
  Home, Wrench, Droplets, Zap, Wind, Trees, Sparkles, Truck,
  HardHat, Stethoscope, Scale, KeyRound, Scissors, Car, PawPrint, Bug
} from 'lucide-react';

const industries = [
  { icon: HardHat, name: 'Construction & Remodeling', desc: 'Capture project leads and book estimates while you\'re on the job site.', highlight: true },
  { icon: Home, name: 'Roofing', desc: 'Never miss a storm-damage call — quote requests captured 24/7.', highlight: true },
  { icon: Droplets, name: 'Plumbing', desc: 'Emergency calls answered instantly, day or night, with urgent jobs flagged.', highlight: true },
  { icon: Wind, name: 'HVAC', desc: 'Seasonal rush handled — bookings and service calls scheduled automatically.', highlight: true },
  { icon: Zap, name: 'Electrical', desc: 'Qualify jobs and collect details before you ever pick up the phone.', highlight: true },
  { icon: Trees, name: 'Landscaping & Lawn Care', desc: 'Estimates booked and recurring clients managed without interruptions.', highlight: true },
  { icon: Truck, name: 'Junk Removal & Hauling', desc: 'Quote inquiries answered on the spot while your crew stays on the road.', highlight: true },
  { icon: Sparkles, name: 'Cleaning Services', desc: 'New client requests and reschedules handled while your team cleans.', highlight: true },
  { icon: Bug, name: 'Pest Control', desc: 'Urgent infestation calls triaged and booked before competitors answer.' },
  { icon: Car, name: 'Auto Repair & Detailing', desc: 'Appointments and status questions handled while hands are busy.' },
  { icon: Stethoscope, name: 'Clinics & Wellness', desc: 'Appointment scheduling and FAQs answered with a friendly voice.' },
  { icon: Scale, name: 'Law Firms', desc: 'Intake questions asked consistently, leads qualified before consult.' },
  { icon: KeyRound, name: 'Real Estate & Property', desc: 'Showings booked and tenant calls logged around the clock.' },
  { icon: Scissors, name: 'Salons & Barbershops', desc: 'Bookings taken while every chair stays busy.' },
  { icon: PawPrint, name: 'Pet Services', desc: 'Grooming and boarding requests captured while you care for pets.' },
  { icon: Wrench, name: 'Handyman & Repairs', desc: 'Every "can you fix..." call becomes a scheduled, detailed job.' },
];

const Industries = () => {
  return (
    <section id="industries" className="py-20 px-6" data-testid="industries-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-purple-400 text-sm font-semibold tracking-widest uppercase mb-3">Industries</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            Built for businesses that can't stop to answer the phone
          </h2>
          <p className="text-base text-gray-400 max-w-2xl mx-auto">
            Miadesk shines for home services — roofing, plumbing, HVAC and more — where every missed call is a missed job. If your hands are busy, Mia's aren't.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {industries.map((ind) => (
            <div
              key={ind.name}
              data-testid={`industry-card-${ind.name.toLowerCase().replace(/[^a-z]+/g, '-')}`}
              className={`group rounded-xl p-5 border transition-all duration-300 hover:-translate-y-1 ${
                ind.highlight
                  ? 'bg-gradient-to-br from-purple-900/30 to-blue-900/20 border-purple-500/25 hover:border-purple-400/50'
                  : 'bg-white/[0.03] border-white/[0.08] hover:border-white/20'
              }`}
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-3 ${
                ind.highlight ? 'bg-purple-500/20' : 'bg-white/[0.06]'
              }`}>
                <ind.icon className={`w-5 h-5 ${ind.highlight ? 'text-purple-300' : 'text-teal-300'}`} />
              </div>
              <h3 className="text-white font-semibold text-sm mb-1.5">{ind.name}</h3>
              <p className="text-gray-400 text-xs leading-relaxed">{ind.desc}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-gray-500 text-sm mt-8">
          Don't see your industry? Mia learns any business from your profile — <a href="#pricing" className="text-purple-400 hover:text-purple-300 underline underline-offset-4">start your free trial</a> and see for yourself.
        </p>
      </div>
    </section>
  );
};

export default Industries;
